export enum MutationTypes {
    SET_CONTRACT_KIND_LIST = 'SET_CONTRACT_KIND_LIST',
    SET_CONTRACT_LIST = 'SET_CONTRACT_LIST',
    SET_CONTRACT_DOC = 'SET_CONTRACT_DOC',
}
